import * as React from 'react';
import {useTheme} from '@mui/material/styles';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import TabPanel from "../../shared/custom-tabs/tab-panel/TabPanel";
import {useTranslation} from "react-i18next";
import LoginForm from "./login-form/LoginForm";
import RegisterForm from "./register-form/RegisterForm";

export default function AuthTabs() {
    const theme = useTheme();
    const {t} = useTranslation()
    const [value, setValue] = React.useState(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const tabs = [
        {
            label: t('existing_user'),
            component: <LoginForm/>
        },
        {
            label: t('new_user'),
            component: <RegisterForm/>
        }
    ]

    return (
        <Box width={"100%"}>
            <Tabs
                value={value}
                onChange={handleChange}
                variant="fullWidth"
                textColor="primary"
                indicatorColor="primary"
            >
                {tabs.map((t, idx) => (
                    <Tab key={`tab-${idx}`} label={t.label}/>
                ))}
            </Tabs>
            {tabs.map((tab, idx) => (
                    <TabPanel key={`tab-panel-${idx}`} value={value} index={idx} dir={theme.direction}>
                        {tab.component}
                    </TabPanel>
            ))}
        </Box>
    );
}
